import React from 'react';
import { Provider } from 'react-redux';
import 'react-tippy/dist/tippy.css';
import logo from './images/mctc_newlogo_300x194_transparent.png';
import Today from './containers/Today';
import LockedFees from './containers/LockedFees';
import RegistrationFees from './sections/RegistrationFees';
import TitleFees from './sections/TitleFees';
import SalesTaxes from './sections/SalesTaxes';
import OtherTransactionFees from './sections/OtherTransactionFees';
import FeeCalculatorTotal from './sections/FeeCalculatorTotal';
import ResetButton from './containers/ResetButton';
import store from './redux/store';
import { ACTIONS } from './modules/constants';
import formatDate from './modules/formatDate';
import pkg from '../package.json';

import './App.css';

function App() {
  return (
    <Provider store={store}>
      <div className="Wrapper container">
        <div className="FormContent">
          <div className="Header">
            <div className="Header-left">
              <img className="Header-logo" src={logo} alt="Logo" />
            </div>

            <div className="Header-right">
              <h1 className="Section-header Section-header--long">
                Fee Calculator
              </h1>
              <ResetButton label="Reset Form" action={ACTIONS.RESET} />
              <LockedFees />
            </div>
          </div>

          <div className="Section">
            <h1 className="Section-header">Registration Fees</h1>
            <ResetButton
              label="Reset Registration"
              action={ACTIONS.RESET_REGISTRATION}
              className="ResetBtn ResetSectionBtn"
            />
            <Today />
            <RegistrationFees />
          </div>

          <div className="Section">
            <h1 className="Section-header">Title Fees</h1>
            <ResetButton
              label="Reset Title"
              action={ACTIONS.RESET_TITLE_FEES}
              className="ResetBtn ResetSectionBtn"
            />
            <TitleFees />
          </div>

          <div className="Section Section--printHalfWidth">
            <h1 className="Section-header">Sales Taxes</h1>
            <ResetButton
              label="Reset Sales Tax"
              action={ACTIONS.RESET_SALES}
              className="ResetBtn ResetSectionBtn"
            />
            <SalesTaxes />
          </div>

          <div className="Section Section--printHalfWidth">
            <h1 className="Section-header">Other Transaction Fees</h1>
            <ResetButton
              label="Reset Other Fees"
              action={ACTIONS.RESET_OTHER_TRANSACTION_FEES}
              className="ResetBtn ResetSectionBtn"
            />
            <OtherTransactionFees />
          </div>

          <div className="Section TotalSection">
            <FeeCalculatorTotal />
          </div>

          <div className="Section Footer">
            <p>
              Calculations based off of the Fee Calculator PDF developed by John
              Archer (in partnership with the Hillsborough County Tax Collector
              Office). Designed and Developed for the web by{" "}
              <b>David Brierton</b> in the Manatee County Tax Collector Office.{" "}
              <b>Last updated</b> {formatDate(new Date(), false)} (v{pkg.version}). All Fees and Totals contained
              herein are <em>estimations only</em> and are subject to change.
            </p>
          </div>
        </div>
      </div>
    </Provider>
  );
}

export default App;
